import { Box } from "@mui/material";
import { Toast } from "@axismaxlife/unified-ui-components-library";

const SEVERITY_TO_STATE = {
  error: "error",
  success: "success",
  warning: "warning",
  info: "information",
  information: "information",
};

export const AppToast = ({ open, handleClose, message, severity }) => {
  const text =
    typeof message === "string" || typeof message === "number"
      ? `${message}`
      : "";

  if (!open || !text) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: "16px",
        left: "16px",
        right: "16px",
        zIndex: 1400,
        display: "flex",
        justifyContent: "center",
        pointerEvents: "none",
      }}
    >
      <Box
        sx={{ width: "100%", maxWidth: "480px", pointerEvents: "auto" }}
      >
        <Toast
          device="mobile"
          state={SEVERITY_TO_STATE[severity] || "information"}
          title={text}
          width="100%"
          closeIcon
          animationDirection="bottom"
          autoDismiss={6000}
          onClose={handleClose}
        />
      </Box>
    </Box>
  );
};

export default AppToast;
